// flashSaleApi.ts
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const flashSaleApi = createApi({
  reducerPath: 'flashSaleApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://fftestservice.sarsetech.com/',
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('admin_token');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      headers.set(
        'authkey',
        '7b4e1fd03f57885c1ff900ad76ea3810bb7160c7157a4c31cf2de3'
      );
      headers.set('Content-Type', 'application/json');
      return headers;
    },
  }),
  tagTypes: ['FlashSale'],
  endpoints: (build) => ({
    listFlashSales: build.query({
      query: () => ({
        url: 'user/listFlashSales',
        method: 'POST',
        body: {},
      }),
      providesTags: ['FlashSale'],
    }),
    addFlashSale: build.mutation({
      query: (flashSaleData) => ({
        url: 'user/addFlashSale',
        method: 'POST',
        body: flashSaleData,
      }),
      invalidatesTags: ['FlashSale'],
    }),
    deleteFlashSale: build.mutation({
      query: (flash_id) => {
        console.log('Delete mutation called with:', flash_id);
        console.log('Sending body:', { flash_id: Number(flash_id) });
        return {
          url: 'user/deleteFlashSale',
          method: 'POST',
          body: { 
            flash_id: Number(flash_id)
          },
        };
      },
      invalidatesTags: ['FlashSale'],
    }),
  }),
});

export const {
  useListFlashSalesQuery,
  useAddFlashSaleMutation,
  useDeleteFlashSaleMutation,
} = flashSaleApi;